import React from 'react'

import Tab from './Tab'

const DesktopNav = () => (
  <div
    style={{
      display: 'flex',
      marginRight: 24
    }}
  >
    <Tab to="/about">About</Tab>
    <Tab to="/media">Media</Tab>
    <Tab to="/contact">Contact</Tab>
  </div>
)

export default DesktopNav



// WEBPACK FOOTER //
// ./src/components/Layout/nav/DesktopNav/index.js